module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "cookie-blocker"
  }, [(_vm.missingCookies.length) ? _c('div', {
    staticClass: "cookie-blocker__road-block"
  }, [_c('div', {
    staticClass: "cookie-blocker__column"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 62 56"
    }
  }, [_c('title', [_vm._v("warning-icon")]), _c('path', {
    attrs: {
      "d": "M60.46451,48.46751,34.45373,3.53664a3.992,3.992,0,0,0-6.90911,0L1.53482,48.46751a3.992,3.992,0,0,0,3.455,5.988H57.00947a3.992,3.992,0,0,0,3.455-5.988ZM32.619,45.474h-3.071c-.68223,0-1.74406,0-1.74406-1.51649V40.16527c0-1.47848,1.06183-1.51649,1.74406-1.51649h1.9341c2.57833,0,2.7674.3031,2.7674,3.79219C34.24955,45.43594,33.98446,45.474,32.619,45.474Zm.91028-12.551a7.91521,7.91521,0,0,0-.038.91028c-.15106,2.80589-.18907,3.071-1.78158,3.071H30.38231c-1.63052,0-1.63052-.26509-1.82008-2.95793,0-.49217-.038-.75824-.038-1.02333-.26509-4.816-.90979-8.077-.90979-12.09633,0-1.13736,0-2.27473,1.517-2.27473h3.79171c1.51649,0,1.51649,1.13737,1.51649,2.27473C34.4396,24.84592,33.79441,28.145,33.52931,32.923Z",
      "fill": "#b5b5b5"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "cookie-blocker__column"
  }, [_c('h2', {
    staticClass: "cookie-blocker__heading"
  }, [_vm._v("\r\n\t\t\t\tIndhold blokeret\r\n\t\t\t")]), _vm._v(" "), _c('p', {
    staticClass: "cookie-blocker__description"
  }, [_vm._v("\r\n\t\t\t\tDette element kan ikke vises,\r\n\t\t\t\tda du ikke har givet accept til følgende typer af cookies:\r\n\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "cookie-blocker__list-item"
  }, _vm._l((_vm.mappedMissingCookies), function(cookieType) {
    return _c('li', {
      key: cookieType,
      domProps: {
        "innerHTML": _vm._s(cookieType)
      }
    })
  })), _vm._v(" "), _c('p', {
    staticClass: "cookie-blocker__description"
  }, [_vm._v("\r\n\t\t\t\tDu kan ændre dine indstillinger\r\n\t\t\t\tved at klikke på knappen herunder.\r\n\t\t\t")]), _vm._v(" "), _c('button', {
    staticClass: "cookie-blocker__button",
    on: {
      "click": _vm.openCookieBanner
    }
  }, [_vm._v("\r\n\t\t\t\tÅben cookie indstillinger\r\n\t\t\t")])])]) : _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// F:/Solutions/6713ge/master/~/vue-loader/lib/template-compiler?{"id":"data-v-381da1c8"}!./scripts/cookie-blocker/cookie-blocker.html
// module id = 348
// module chunks = 1